<template>
  <j-modal
    :width="900"
    :visible="visible"
    :mask="true"
    :fullscreen="izMobile"
    class="j-super-query-modal"
    style="top: 0%; max-height: 95%"
    @cancel="handleCancel"
    @ok="handleOk"
    :footer="null"
  >
    <div slot="title">
      <span class="title">{{ currStudentInfo.name }}【{{ title }}】</span>
      <a-button type="primary" @click="exportToPdf">导出</a-button>
    </div>
    <div ref="exportContent">
      <a-card class="card-box" :bordered="false" :style="{ marginBottom: '24px' }">
        <div class="line-title title" style="margin-bottom: 5px">
          <div>{{ currStudentInfo.name }}{{ studentAnalysis.tendency.title }}</div>
          <div>
            <a-select
              v-model="timeType"
              placeholder="请选择事件类型"
              :options="timeTypeOptions"
              @select="selectTimeType"
            />
          </div>
        </div>
        <div class="salesCard">
          <!-- <smooth-line-chart-multid
            :height="220"
            :fields="studentAnalysis.tendency.moodField"
            :dataSource="studentAnalysis.tendency.dataSource"
            :yAxisMultiple="1.15"
            :isWatchGuide="true"
            :loadingChart="loadingChart"
            :isShowNoDataIcon="true"
          /> -->
          <LineChart
            height="220px"
            :fields="studentAnalysis.tendency.moodField"
            :dataSource="studentAnalysis.tendency.dataSource"
          />
        </div>
      </a-card>
      <a-card class="card-box" :bordered="false" :style="{ marginBottom: '24px' }">
        <div class="line-title">
          <div class="title">{{ currStudentInfo.name }}{{ studentAnalysis.undulate.title }}</div>
        </div>
        <div class="salesCard">
          <!-- <smooth-line-chart-multid
            :height="220"
            :fields="studentAnalysis.undulate.moodField"
            :dataSource="studentAnalysis.undulate.dataSource"
          /> -->
          <LineChart
            height="220px"
            :fields="studentAnalysis.undulate.moodField"
            :dataSource="studentAnalysis.undulate.dataSource"
          />
        </div>
      </a-card>
      <a-card class="card-box" :bordered="false" :style="{ marginBottom: '24px' }">
        <div class="line-title title">
          <div>{{ currStudentInfo.name }}{{ studentAnalysis.forewarning.title }}</div>
        </div>
        <div class="salesCard">
          <!-- <smooth-line-chart-multid
            :height="220"
            :fields="studentAnalysis.forewarning.moodField"
            :dataSource="studentAnalysis.forewarning.dataSource"
          /> -->
          <LineChart
            height="220px"
            :fields="studentAnalysis.forewarning.moodField"
            :dataSource="studentAnalysis.forewarning.dataSource"
          />
        </div>
      </a-card>
      <a-card
        v-for="(item, index) in studentSituation"
        :key="index"
        class="card-box"
        :bordered="false"
        :style="{ marginBottom: '24px' }"
      >
        <div class="line-title title">
          <div>{{ currStudentInfo.name }}{{ item.title }}</div>
        </div>
        <div class="salesCard">
          <!-- <smooth-line-chart-multid
            :height="220"
            :fields="item.moodField"
            :dataSource="item.dataSource"
          /> -->
          <LineChart height="220px" :fields="item.moodField" :dataSource="item.dataSource" />
        </div>
      </a-card>
      <a-card
        v-for="(item, index) in studentRecord"
        :key="index"
        class="card-box"
        :bordered="false"
        :style="{ marginBottom: '24px' }"
      >
        <TableList
          :titleStyle="{ fontSize: '15px', marginBottom: '10px' }"
          :title="`${currStudentInfo.name + item.title}`"
          :columns="item.columns"
          :tableData="item.tableData"
        />
      </a-card>
    </div>
  </j-modal>
</template>

<script>
import JDate from '@/components/jeecg/JDate.vue'
import SmoothLineChartMultid from '@/components/chart/SmoothLineChartMultid'
import { getAction } from '@api/manage'
import TableList from '@/components/chart/TableList'
import html2canvas from 'html2canvas'
import jsPDF from 'jspdf'
import LineChart from '@/components/echartZyz/components/LineChart'

import { handleLineChartData } from '@/utils/util'

export default {
  name: 'ViewKeyPointModal',
  components: {
    JDate,
    SmoothLineChartMultid,
    TableList,
    LineChart,
  },
  props: {
    title: {
      type: String,
      default: '情绪趋势分析',
    },
  },
  data() {
    return {
      visible: false,
      labelCol: { span: 3 },
      wrapperCol: { span: 14 },
      form: {
        time: '',
        eventsType: '',
        eventsContent: '',
      },
      addEventId: '',
      currStudentInfo: {},
      timeType: 'last7days',
      timeTypeOptions: [
        // {
        //   label: '今天',
        //   value: 'today',
        // },
        {
          label: '近七天',
          value: 'last7days',
        },
        {
          label: '近20天',
          value: 'last20days',
        },
        {
          label: '近40天',
          value: 'last40days',
        },
        {
          label: '近三个月',
          value: 'last3months',
        },
        {
          label: '近半年',
          value: 'last6months',
        },
      ],
      //   今天 today 近七天 last7days 近20天 last20days 近40天 last40days 近三个月 last3months 近半年 last6months
      studentAnalysis: {
        // 情绪趋势分析
        tendency: {
          title: '【情绪趋势分析】',
          dataSource: [],
          moodField: [],
        },
        // 情绪波动指数趋势
        undulate: {
          title: '【情绪波动指数趋势】',
          dataSource: [],
          moodField: [],
        },
        // 提醒次数
        forewarning: {
          title: '【提醒次数】',
          dataSource: [],
          moodField: [],
        },
      },
      studentSituation: [
        // {
        //   title: '【学生情况】',
        //   dataSource: [],
        //   moodField: [],
        // },
        {
          title: '【家长关注度】',
          dataSource: [],
          moodField: [],
        },
        // {
        //   title: '【成绩详情】',
        //   dataSource: [],
        //   moodField: [],
        // },
        // {
        //   title: '',
        //   dataSource: [],
        //   moodField: [],
        // },
      ],
      studentRecord: [
        {
          title: '【教师辅导记录】',
          columns: [
            {
              title: '辅导日期',
              dataIndex: 'create_time',
            },
            {
              title: '辅导老师',
              dataIndex: 'realname',
            },
            {
              title: '辅导反馈',
              dataIndex: 'comment',
            },
          ],
          tableData: [],
        },
        {
          title: '【事件记录】',
          columns: [
            {
              title: '日期',
              dataIndex: 'create_time',
            },
            {
              title: '添加人',
              dataIndex: 'name',
            },
            {
              title: '事件详情',
              dataIndex: 'comment',
            },
          ],
          tableData: [],
        },
      ],
      dataType: '',
    }
  },
  computed: {
    izMobile() {
      return this.device === 'mobile'
    },
  },
  methods: {
    resetModal() {
      this.studentAnalysis = {
        tendency: {
          title: '【情绪趋势分析】',
          dataSource: [],
          moodField: [],
        },
        undulate: {
          title: '【情绪波动指数趋势】',
          dataSource: [],
          moodField: [],
        },
        forewarning: {
          title: '【提醒次数】',
          dataSource: [],
          moodField: [],
        },
      }
    },
    show(data, type) {
      console.log('currStudentInfo--', data)
      this.visible = true
      this.currStudentInfo = data
      this.dataType = type
      this.getChildWarnNumTrend(data)
    },
    close() {
      this.$emit('close')
      this.visible = false
      this.resetModal()
      this.timeType = 'last7days'
    },
    handleCancel() {
      this.close()
    },
    handleOk() {},
    selectTimeType() {
      this.getChildWarnNumTrend()
    },
    exportToPdf() {
      const element = this.$refs.exportContent
      // 使用html2canvas将内容转换为PNG图片
      html2canvas(element, {
        useCORS: true, // 允许使用跨域图像
      }).then((canvas) => {
        const imgData = canvas.toDataURL('image/jpeg')

        // 创建一个新的jsPDF实例
        const pdf = new jsPDF()
        const imgWidth = 210 - 20 // A4页面宽度减去左右内边距（20mm）
        const pageHeight = pdf.internal.pageSize.height // 获取PDF页面高度

        const imgHeight = (canvas.height * imgWidth) / canvas.width // 根据比例计算图片高度
        let heightLeft = imgHeight // 剩余高度
        let position = 10 // 初始位置（顶部内边距10mm）

        // 分页处理
        while (heightLeft >= 0) {
          pdf.addImage(imgData, 'JPEG', 10, position, imgWidth, imgHeight) // 左右各10mm内边距
          heightLeft -= pageHeight // 减去页面高度
          position -= pageHeight // 移动位置至下一页
          if (heightLeft >= 0) {
            pdf.addPage() // 需要新页面时，添加新页面
          }
        }

        // 保存PDF文件
        pdf.save(`${this.currStudentInfo.name + '-' + this.title}.pdf`)
      })
    },
    async getChildWarnNumTrend() {
      this.loadingChart = true
      const res = await getAction('/statistic/childWarnNumTrend', {
        studentId: this.currStudentInfo.id,
        type: this.timeType,
        dataType: this.dataType,
      })
      if (res.code == 200 && res.success) {
        // 变化趋势
        const { filedList, lineData } = handleLineChartData(res.result.moodScoreAndWarnNumTrend)
        this.$set(this.studentAnalysis.tendency, 'dataSource', lineData)
        this.$set(this.studentAnalysis.tendency, 'moodField', filedList)
        // 情绪波动指数
        const studentVarianceUndulateTrend = res.result.studentVarianceUndulateTrend
        const undulateMoodField =
          studentVarianceUndulateTrend.length > 0
            ? Object.keys(studentVarianceUndulateTrend[0]).filter((key) => key != 'type')
            : []
        this.$set(this.studentAnalysis.undulate, 'dataSource', studentVarianceUndulateTrend)
        this.$set(this.studentAnalysis.undulate, 'moodField', undulateMoodField)
        // 提醒次数
        const warnTrend = res.result.warnTrend
        const forewarningMoodField =
          warnTrend.length > 0 ? Object.keys(warnTrend[0]).filter((key) => key != 'type') : []
        this.$set(this.studentAnalysis.forewarning, 'dataSource', warnTrend)
        this.$set(this.studentAnalysis.forewarning, 'moodField', forewarningMoodField)
        // 家长关注度
        const parentAttention = res.result.parentAttention
        const mapParentAttention =
          parentAttention.length > 0
            ? parentAttention.map((item) => {
                return {
                  type: item.visit_date,
                  家长关注度: item.parentVisitCnt,
                }
              })
            : []
        this.$set(this.studentSituation[0], 'dataSource', mapParentAttention)
        this.$set(this.studentSituation[0], 'moodField', ['家长关注度'])
        // 教师辅导记录和事件记录
        this.$set(this.studentRecord[0], 'tableData', res.result.tutoringRecord)
        this.$set(this.studentRecord[1], 'tableData', res.result.eventRecord)
        this.loadingChart = false
      }
    },
  },
}
</script>

<style lang="less" scoped>
.title {
  font-size: 15px;
  font-weight: bold;
  margin-right: 12px;
}
.card-box {
  border: 1px solid #e4e4e4;
  border-radius: 10px;
  margin: 10px;
  ::v-deep {
    .ant-card-body {
      padding: 10px;
    }
  }
  .line-title {
    display: flex;
    align-items: center;
    justify-content: space-between;
    ::v-deep {
      .ant-select {
        width: 100px !important;
      }
    }
  }
}
</style>
